import { useI18n, type StringKey } from "../i18n";
import type { DocStatus, EmploymentStatus } from "../types";

const empTone: Record<EmploymentStatus, string> = { active: "success", probation: "warning", starting: "info", terminated: "neutral" };
const empKey: Record<EmploymentStatus, StringKey> = {
  active: "statusActive",
  probation: "statusProbation",
  starting: "statusStarting",
  terminated: "statusTerminated",
};

export function EmploymentBadge({ status }: { status: EmploymentStatus }) {
  const { t } = useI18n();
  return <span className={`badge ${empTone[status]}`}>{t(empKey[status])}</span>;
}

const docTone: Record<DocStatus, string> = {
  pending: "warning",
  overdue: "danger",
  received: "success",
  expiring: "warning",
  expired: "danger",
  waived: "neutral",
  rejected: "danger",
};

export function DocBadge({ status }: { status: DocStatus }) {
  const { t } = useI18n();
  return <span className={`badge ${docTone[status]}`}>{t(`docStatus_${status}` as StringKey)}</span>;
}
